module.exports = __webpack_public_path__ + "static/media/yewu-cj2.c36c888f.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/yewu-cj2.png
// module id = 602
// module chunks = 0